<template>
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
  >
    <path d="M10.4988 11.9992C10.7756 11.9992 11 12.2232 11 12.4996C11 12.7452 10.8227 12.9496 10.5889 12.9919L10.4988 13H0.501207C0.224398 13 0 12.776 0 12.4996C0 12.2539 0.177302 12.0496 0.411114 12.0072L0.501207 11.9992H10.4988ZM15.4991 6.00706C15.7757 6.00706 16 6.23111 16 6.50748C16 6.75315 15.8228 6.95747 15.5891 6.99985L15.4991 7.00791H0.500946C0.224281 7.00791 0 6.78386 0 6.50748C0 6.26182 0.17721 6.05749 0.4109 6.01512L0.500946 6.00706H15.4991ZM11.5002 0C11.7769 0 12.0012 0.224048 12.0012 0.500425C12.0012 0.746093 11.824 0.950415 11.5903 0.992787L11.5002 1.00085H0.500946C0.224281 1.00085 0 0.776802 0 0.500425C0 0.254756 0.17721 0.0504345 0.4109 0.0080626L0.500946 0H11.5002Z" />
  </svg>
</template>
